import {Instagram} from 'lucide-react'

/**
 * Componente "Quem criou o Sistema Descubra seus Óleos".
 *
 * COMO TROCAR A FOTO:
 * Basta atualizar a constante FOTO_MONICA abaixo com a nova URL
 * da imagem (recomendado: 400x400px, quadrada, formato png/jpg/webp).
 * A imagem fica hospedada externamente para facilitar substituição
 * sem precisar mexer em mais nenhum arquivo.
 */
const FOTO_MONICA = 'https://static.lumi.new/b2/b2c0441cd263f605e6a1cd0bab42c1dc.webp'

interface SobreMonicaProps {
  /** Variante do texto. 'capacitacao' = página /capacitacao. 'consultora' = página /assinar. */
  variante: 'capacitacao' | 'consultora'
  /** Mostrar handle @descubraseusoleos no final (apenas variante consultora). */
  mostrarInstagram?: boolean
}

function SobreMonica({ variante, mostrarInstagram = false }: SobreMonicaProps) {
  const paragrafos =
    variante === 'capacitacao'
      ? [
          'Olá! Eu sou a Mônica Maria, aromaterapeuta e terapeuta integrativa.',
          'Desde 2019 trabalho com óleos essenciais transformando a saúde física e emocional de centenas de pessoas.',
          'Criei o curso Uma Gota de Equilíbrio e o Sistema Descubra seus Óleos porque acredito que qualquer pessoa com vontade de aprender pode transformar vidas e construir uma renda com saúde e bem-estar.',
          'Estou aqui para te mostrar como.',
        ]
      : [
          'Olá! Eu sou a Mônica Maria, aromaterapeuta e terapeuta integrativa.',
          'Desde 2019 trabalho com óleos essenciais transformando a saúde física e emocional de centenas de pessoas.',
          'Criei o Sistema Descubra seus Óleos para ajudar consultores(as) de óleos essenciais a atender com mais profissionalismo, captar leads de forma automática e fechar mais vendas com método e estratégia.',
          'O sistema já está transformando atendimentos e gerando resultados reais para consultores(as) que fazem parte da nossa comunidade.',
        ]

  return (
    <section className="px-4 sm:px-6 py-12 sm:py-16">
      <div className="max-w-5xl mx-auto bg-white rounded-3xl border border-[#EDE0D4] shadow-sm p-6 sm:p-10 md:p-12">
        <div className="text-center mb-8 sm:mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#D8F3DC] text-[#2D6A4F] text-xs sm:text-sm font-medium mb-3">
            Sobre a criadora
          </span>
          <h2 className="font-cormorant text-2xl sm:text-4xl font-semibold text-[#2C2C2A]">
            Quem criou o Sistema Descubra seus Óleos
          </h2>
        </div>

        <div className="flex flex-col md:flex-row items-center md:items-start gap-6 sm:gap-8 md:gap-10">
          {/* Foto */}
          <div className="shrink-0">
            <div className="w-48 h-48 sm:w-56 sm:h-56 md:w-[280px] md:h-[280px] rounded-3xl overflow-hidden border-4 border-[#D8F3DC] shadow-md bg-[#F8F4EF]">
              <img
                src={FOTO_MONICA}
                alt="Mônica Maria - aromaterapeuta e terapeuta integrativa"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          {/* Texto */}
          <div className="flex-1 space-y-4 text-center md:text-left">
            {paragrafos.map((p, i) => (
              <p
                key={i}
                className={`text-[#2C2C2A] text-sm sm:text-base leading-relaxed ${
                  i === 0 ? 'font-medium text-base sm:text-lg' : ''
                }`}
              >
                {p}
              </p>
            ))}

            {mostrarInstagram && (
              <a
                href="https://www.instagram.com/descubraseusoleos"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 mt-2 text-[#2D6A4F] hover:text-[#1f4f3a] font-medium text-sm sm:text-base transition-colors"
              >
                <Instagram size={18} />
                @descubraseusoleos
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default SobreMonica
